import { z } from 'zod';

/**
 * PAYMENT ACCOUNT (ARCHITECTURE_CORRECTION_PLAN §E).
 *
 * Exactly one organisation-level record: the receiving bank account that renewal/service payments
 * are transferred to. Exactly three fields; never copied into users or services. Viewing needs
 * `payment_account.view` (Admin and Operations); setting needs `payment_account.manage` (Admin).
 *
 * Unrelated to the Bekebi User ID (BEKEBI-000001), which only identifies a portal user.
 */
const bankField = z.string().trim().min(1).max(200);

export const paymentAccountSetSchema = z.strictObject({
  bankAccountName: bankField,
  bankName: bankField,
  bankAccountNumber: bankField,
});
export type PaymentAccountSet = z.infer<typeof paymentAccountSetSchema>;

export const paymentAccountResponseSchema = z.object({
  paymentAccount: z
    .object({
      bankAccountName: z.string(),
      bankName: z.string(),
      bankAccountNumber: z.string(),
      updatedAt: z.string(),
    })
    .nullable(),
});
export type PaymentAccountResponse = z.infer<typeof paymentAccountResponseSchema>;
